export const duplicateFavoriteDisplayNameTemplate = "AzGVnd";
export const duplicateFavoriteTooltipTemplate = "gyJ$3d";
export default {duplicateFavoriteDisplayNameTemplate,duplicateFavoriteTooltipTemplate};